import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";

export const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#f1f3f9",
    color: "#172b4d",
    fontSize: 16,
  },
  body: {
    fontSize: 16,
    backgroundColor: (props) =>
      props.disabled ? theme.palette.grey[100] : "unset",
    opacity: (props) => (props.disabled ? 0.75 : 1),
    // padding: 8,
  },
}))(TableCell);

export const TableRowHead = withStyles((theme) => ({
  root: {
    backgroundColor: "#f1f3f9",
    color: "#172b4d",
  },
}))(TableRow);

export const StyleCheckbox = withStyles((theme) => ({
  root: {
    borderRadius: 6,
    color: "#8898aa",
    "&$checked": {
      color: theme.palette.success.main,
    },
  },
  checked: {},
}))(Checkbox);

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: 0,
    // width: '100%',
  },
  currencyCode: {
    margin: theme.spacing(1),
    width: 100,
  },
  title: {
    color: theme.palette.darkIndigo.main,
  },
  subTitle: {
    "& a": {
      color: theme.palette.secondary.main,
    },
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  circle: {
    width: 25,
    height: 25,
    borderRadius: 25,
    backgroundColor: theme.palette.error.main,
  },
  triangle: {
    margint: 0,
    padding: 0,
    fontSize: 30,
    color: theme.palette.success.main,
  },
  table: {
    minWidth: 700,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
      borderRight: "1px solid rgba(224, 224, 224, 1)",
    },
  },
  badge: {
    display: "flex",
    width: 25,
    height: 25,
    borderRadius: 25,
    backgroundColor: "#feb969",
    marginRight: 8,
    textAlign: "center",
    color: "#fff",
    justifyContent: "center",
    alignItems: "center",
  },
  wrapTitleContent: {
    width: 36,
    display: "flex",
    justifyContent: "center",
    marginRight: 3,
    marginLeft: 8,
  },
  tableTitle: {
    color: "#8898aa",
    marginLeft: 16,
  },
  cellContent: {
    display: "flex",
  },
  cellContentWithRowSpan: {
    display: "flex",
    flex: 1,
  },
  wrapField: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },
  textField: {
    display: "flex",
    flex: 1,
    cursor: "pointer",
    marginTop: 8,
    "& .MuiInputBase-root.Mui-disabled": {
      backgroundColor: theme.palette.grey[100],
    },
  },
  textFieldSuccess: {
    color: theme.palette.success.main,
  },
  notchedOutlineSuccess: {
    borderColor: theme.palette.success.main,
  },
  textSuccess: {
    color: theme.palette.success.main,
  },
  multiline: {
    marginTop: 4,
    height: "150px !important",
  },
  formControl: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(2),
    minWidth: 120,
    // width: 300,
  },
  buttonUpload: {
    height: 44,
  },
  translateIco: {
    color: "#40B8D4",
    fontSize: "25px",
    cursor: "pointer",
  },
}));

export const Bagde = ({ number }) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapTitleContent}>
      {!!number && <div className={classes.badge}>{number}</div>}
    </div>
  );
};

export function UploadButton({
  id,
  onChange,
  title,
  disabled,
  size,
  height,
  style,
}) {
  const classes = useStyles();
  return (
    <div>
      <input
        style={{ display: "none" }}
        id={`contained-button-file-${id}`}
        type="file"
        onChange={onChange}
        disabled={disabled}
      />
      <label htmlFor={`contained-button-file-${id}`}>
        <ColorButton
          component="span"
          fullWidth={false}
          classes={{ root: classes.buttonUpload }}
          variant="outlined"
          color="info"
          size={size}
          style={style}
          disabled={disabled}
        >
          {title || "BROWSE"}
        </ColorButton>
      </label>
    </div>
  );
}
